<!--
 * @Author: 仙道
 * @Date: 2022-07-02 21:37:01
 * @LastEditTime: 2022-07-02 21:43:28
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/components/jeecgbiz/JSelectDevicePlan.vue
-->
 
<template>
  <j-select-biz-component :width="1000" returnId v-bind="configs" v-on="$listeners" />
</template>

<script>
  import JSelectBizComponent from './JSelectBizComponent'
  import { filterDictTextByCache } from '@/components/dict/JDictSelectUtil'

  export default {
    name: 'JSelectDevicePlan',
    components: { JSelectBizComponent },
    props: ['value'],
    // 保养计划
    data () {
      return {
        settings: {
          name: '保养计划',
          displayKey: 'planName',
          valueKey: 'id',
          returnKeys: ['id', 'planName'],
          listUrl: '/maintenance/devMaintaincePlan/list',
          queryParamCode: 'planName',
          queryParamText: '计划名称',
          columns: [
            {
              title: '计划名称',
              align: 'center',
              dataIndex: 'planName'
            },
            {
              title: '计划周期',
              align: "center",
              dataIndex: 'planCycle',
              customRender: function (text) {
                return filterDictTextByCache('planning_cycle', text)
              }
            },
            {
              title: '计划类型',
              align: "center",
              dataIndex: 'planType',
              customRender: function (text) {
                return filterDictTextByCache('plan_class', text)
              }
            },
            // { title: '分类编码', dataIndex: 'typeCode', align: 'center', width: '30%', widthRight: '70%' },
            // devCode

          ]
        }
      }
    },
    computed: {
      configs () {
        return Object.assign({ value: this.value }, this.settings, this.$attrs)
      }
    }
  }
</script>

<style lang="less" scoped></style>
